import React, { useState, useImperativeHandle, useRef, forwardRef } from 'react';
import { FormGroup, Input, Select, DatePicker } from '@tencent/spaui';
import FileUpload from '../components/FileUpload';
import MediaUpload from '../components/MediaUpload';
import MultiUpload from '../components/MultiUpload';
import { CAPITAL } from '../const/constant';
import dayjs from 'dayjs';
import './info-common.scss';

// 资质信息
// 公司主体名称	company_name
// 统一社会信用代码	company_license_no
// 注册地址	company_reg_address
// 注册资本	company_capital_situation
// 证件有效期	company_expiretime
// 法人姓名	company_owner
// 法人证件正面	company_owner_idfront
// 法人证件反面	company_owner_idback
// 公众号名称	mp_name
// 公众号ID	mp_id
// 营业执照	company_certification
// ICP备案号	icp_no
// ICP 许可证 icp_licenses
// 著作权证明	company_copyright

const baseState = {
  company_name: '', // 公司主体名称
  company_license_no: '', // 统一社会信用代码
  company_reg_address: '', // 注册地址
  company_capital_situation: '', // 注册资本
  company_owner_idfront: '', // 法人证件正面
  company_owner_idback: '', // 法人证件反面
  company_certification: '', // 营业执照
  icp_no: '',
  icp_licenses: [] as any[],
  company_copyright: '',
};

// const baseState = {
//   company_name: '志哥家', // 公司主体名称
//   company_owner: '志哥', // 法人姓名
//   company_license_no: '123123', // 统一社会信用代码
//   company_reg_address: '阿斯顿发', // 注册地址
//   company_capital_situation: 2, // 注册资本
//   company_expiretime: '2022-04-08',
//   company_owner_idfront: "http://pgdt.gtimg.cn/gdt/0/6dc91d367f71c3c599d0aa1f9b3701ed.IMG/0?ck=fde0cde358a37da7a8a736ea5091a7f2", // 法人证件正面
//   company_owner_idback: "http://pgdt.gtimg.cn/gdt/0/6dc91d367f71c3c599d0aa1f9b3701ed.IMG/0?ck=fde0cde358a37da7a8a736ea5091a7f2", // 法人证件反面
//   company_certification: "http://pgdt.gtimg.cn/gdt/0/6dc91d367f71c3c599d0aa1f9b3701ed.IMG/0?ck=fde0cde358a37da7a8a736ea5091a7f2", // 营业执照
//   mp_name: 'asb',
//   mp_id: '123123',
//   icp_no: "http://pgdt.gtimg.cn/gdt/0/6dc91d367f71c3c599d0aa1f9b3701ed.IMG/0?ck=fde0cde358a37da7a8a736ea5091a7f2",
//   company_copyright: "http://pgdt.gtimg.cn/gdt/0/6dc91d367f71c3c599d0aa1f9b3701ed.IMG/0?ck=fde0cde358a37da7a8a736ea5091a7f2",
// };

const FormExamStrateg: { [key: string]: any } = {
  // 公司主体名称
  company_name: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  // 统一社会信用代码
  company_license_no: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 18) {
      return '长度过长';
    }
    return false;
  },
  // 注册地址
  company_reg_address: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  // 注册资本
  company_capital_situation: (value: any) => {
    if (!value) {
      return '请选择';
    }
    return false;
  },
  // 证件有效期
  company_expiretime: (value: any) => {
    if (!value) {
      return '请选择';
    }
    return false;
  },
  // 法人姓名
  company_owner: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length < 2) {
      return '内容过短';
    }
    if (value.length > 20) {
      return '长度过长';
    }
    return false;
  },
  // 法人证件 正反面
  company_owner_certificate: (value: any, formData: any) => {
    if (!formData.company_owner_idfront || !formData.company_owner_idback) {
      return '请上传身份证件';
    }
    return false;
  },
  // 公众号名称
  mp_name: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  // 公众号 ID
  mp_id: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  // 营业执照
  company_certification: (value: any) => {
    if (!value) {
      return '请上传营业执照';
    }
    return false;
  },
  // ICP备案号
  icp_no: (value: any) => {
    if (!value) {
      return '请上传ICP备案号';
    }
    return false;
  },
  // 著作权证明
  company_copyright: (value: any) => {
    if (!value) {
      return '请上传著作权证明';
    }
    return false;
  },
};

// const Feedback = (num: number, total: number) => (
//   <span>
//     <span className="spaui-input-feedback-count">{num}</span>
//     <span className="spaui-input-feedback-divider">/</span>
//     <span className="spaui-input-feedback-range">{total}</span>
//   </span>
// );

interface Props {
  children?: React.FunctionComponent<{ submit: () => void }>;
  onSubmit?: (data: any) => void;
  initData?: { [key: string]: any };
}

const shortcuts = [{ date: '2199-12-31', label: '长期' }];

// 资质信息
// eslint-disable-next-line react/display-name
const BaseInfo: React.FC<Props> = forwardRef((props, cref) => {
  // 表单所有数据
  const [formData, setFormData] = useState<{ [key: string]: any }>({
    ...baseState,
    ...props.initData,
  });
  // 表单项检查
  const [formExam, setFormExam] = useState<{ [key: string]: any }>({});

  const setFormValue = (name: string, value: any) => {
    formData[name] = value;
    setFormData({ ...formData });
  };

  // 返回 true 代表表单正确
  const checkForm = (key: string): boolean => {
    const res = FormExamStrateg[key]?.(formData[key], formData);
    formExam[key] = res;
    setFormExam({ ...formExam });
    return !res;
  };

  const submit = () => {
    const result = Object.keys(FormExamStrateg).map((item) => checkForm(item));
    if (result.includes(false)) {
      return;
    }
    // const submitData = {
    //   ...formData,
    //   company_owner_certificate: formData.company_owner_certificate?.url, // 法人证件 正反面
    //   company_owner_idback: formData.company_owner_idback?.url, // 法人证件 正反面
    //   company_certification: formData.company_owner_certificate?.url, // 营业执照url
    //   icp_no: formData.icp_no?.url, // ICP备案号
    //   company_copyright: formData.company_copyright?.url, // 著作权证明
    // };
    props.onSubmit?.(formData);
    return formData;
  };

  const Component = props.children;

  const contentRef = useRef();
  useImperativeHandle(cref, () => ({
    submit,
  }));

  return (
    <div ref={contentRef}>
      <div className="info-content">
        <div className="form-line">
          <span className="form-label">公司主体名称</span>
          <FormGroup
            className="form-item"
            error={formExam.company_name}
            // feedback={Feedback(formData['company_name'].length, 20)}
          >
            <Input
              placeholder="请输入公司主体名称"
              value={formData.company_name}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_name', value.trim());
                checkForm('company_name');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">统一社会信用代码</span>
          <FormGroup
            className="form-item"
            error={formExam.company_license_no}
            // feedback={Feedback(formData['company_name'].length, 20)}
          >
            <Input
              placeholder="请输入统一社会信用代码"
              value={formData.company_license_no}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_license_no', value.trim());
                checkForm('company_license_no');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">注册地址</span>
          <FormGroup
            className="form-item"
            error={formExam.company_reg_address}
            // feedback={Feedback(formData['company_name'].length, 20)}
          >
            <Input
              placeholder="请输入注册地址"
              value={formData.company_reg_address}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_reg_address', value.trim());
                checkForm('company_reg_address');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">注册资本</span>
          <FormGroup className="form-item" error={formExam.company_capital_situation}>
            <Select
              value={formData.company_capital_situation}
              data={Object.keys(CAPITAL).map((item) => ({ value: item, label: CAPITAL[item] }))}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_capital_situation', +value);
                checkForm('company_capital_situation');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">证件有效期</span>
          <FormGroup className="form-item" error={formExam.company_expiretime}>
            <div style={{ display: 'flex' }}>
              <Select
                style={{ width: '100px' }}
                data={[
                  { label: '长期', value: '3000-01-01' },
                  { label: '短期', value: '2022-01-01' },
                ]}
                value={
                  dayjs(formData.company_expiretime).format('YYYY-MM-DD') === '3000-01-01' ? '3000-01-01' : '2022-01-01'
                }
                onChange={(e: EventTarget, value: string) => {
                  setFormValue('company_expiretime', value);
                }}
              />
              {dayjs(formData.company_expiretime).format('YYYY-MM-DD') !== '3000-01-01' && (
                <DatePicker
                  date={formData.company_expiretime}
                  type="single"
                  picker="date"
                  useShortcut
                  shortcuts={shortcuts}
                  optionalStartDate={'2022-01-01'}
                  optionalEndDate={'2200-01-01'}
                  onChange={(event: EventTarget, value) => {
                    setFormValue('company_expiretime', value);
                    checkForm('company_expiretime');
                  }}
                />
              )}
            </div>
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">法人姓名</span>
          <FormGroup
            className="form-item"
            error={formExam.company_owner}
            // feedback={Feedback(formData['company_name'].length, 20)}
          >
            <Input
              placeholder="请输入法人姓名"
              value={formData.company_owner}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_owner', value.trim());
                checkForm('company_owner');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">法人证件</span>
          <FormGroup className="form-item" error={formExam.company_owner_certificate}>
            <div className="pic-upload">
              <div>
                <div style={{ paddingRight: '14px' }}>身份证正面</div>
                <MediaUpload
                  value={formData.company_owner_idfront}
                  onDelete={() => {
                    setFormValue('company_owner_idfront', '');
                  }}
                  onChange={(value) => {
                    setFormValue('company_owner_idfront', value);
                  }}
                />
              </div>
              <div>
                <div style={{ paddingRight: '14px' }}>身份证反面</div>
                <MediaUpload
                  value={formData.company_owner_idback}
                  onDelete={() => {
                    setFormValue('company_owner_idback', '');
                  }}
                  onChange={(value) => {
                    setFormValue('company_owner_idback', value);
                  }}
                />
              </div>
            </div>
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公众号名称</span>
          <FormGroup
            className="form-item"
            error={formExam.mp_name}
            // feedback={Feedback(formData['company_name'].length, 20)}
          >
            <Input
              placeholder="请输入公众号名称"
              value={formData.mp_name}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('mp_name', value.trim());
                checkForm('mp_name');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公众号 ID</span>
          <FormGroup
            className="form-item"
            error={formExam.mp_id}
            // feedback={Feedback(formData['company_name'].length, 20)}
          >
            <Input
              placeholder="请输入公众号 ID"
              value={formData.mp_id}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('mp_id', value.trim());
                checkForm('mp_id');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">营业执照</span>
          <FormGroup className="form-item" error={formExam.company_certification}>
            <FileUpload
              value={formData.company_certification}
              onDelete={() => setFormValue('company_certification', '')}
              onChange={(data) => {
                setFormValue('company_certification', data);
                checkForm('company_certification');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">ICP备案号</span>
          <FormGroup className="form-item" error={formExam.icp_no}>
            <MultiUpload
              data={formData.icp_no}
              max={5}
              onChange={(list) => {
                setFormValue('icp_no', list);
                checkForm('icp_no');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">ICP许可证</span>
          <FormGroup className="form-item" error={formExam.icp_licenses}>
            <MultiUpload
              data={formData.icp_licenses}
              max={10}
              onChange={(list) => {
                setFormValue('icp_licenses', list);
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">著作权证明</span>
          <FormGroup className="form-item" error={formExam.company_copyright}>
            <FileUpload
              value={formData.company_copyright}
              onDelete={() => setFormValue('company_copyright', '')}
              onChange={(data) => {
                setFormValue('company_copyright', data);
                checkForm('company_copyright');
              }}
            />
          </FormGroup>
        </div>
      </div>
      <div style={{ display: 'inline-block' }}>{Component && <Component submit={submit} />}</div>
    </div>
  );
});

export default BaseInfo;
